import { Layers } from 'lucide-react';
import { EmptyStateBrand } from '@/components/operator/EmptyStateBrand';

interface CanvasEmptyStateProps {
  /** While true, the icon pulses and the caption swaps to "Loading surface content…". */
  loading?: boolean;
}

/**
 * Centered Canvas empty state. Used both by `CanvasPanel` when no
 * canvases are open and by `OperatorLoadingSkeleton` while a conversation
 * is hydrating, so the crossfade lands on the same DOM and there's no
 * structural change once the live panel mounts.
 *
 * Shares `EmptyStateBrand` with the thread empty state so both sides sit
 * at the same eyeline with the same brand mark and halo. The `pb-20` offset
 * compensates for the missing composer on the canvas side.
 */
export function CanvasEmptyState({ loading = false }: CanvasEmptyStateProps) {
  return (
    <div data-testid="canvas-panel" className="h-full">
      <EmptyStateBrand
        title="Canvas"
        description={
          loading
            ? 'Loading surface content…'
            : 'Agent generated UI will appear here when the agent renders surfaces.'
        }
        icon={<Layers className="h-7 w-7 text-foreground" />}
        bottomOffsetClass="pb-20"
        loading={loading}
      />
    </div>
  );
}
